import { ChevronRightIcon } from '@/shared/ui/icons'
import styles from './ModuleTile.module.css'

type ModulePillProps = {
  name: string
}

/** The expanded card's slot in the sidebar: its name and a chevron. */
export const ModulePill = ({ name }: ModulePillProps) => (
  <div className={styles.pill}>
    <span className={styles.title}>{name}</span>
    <ChevronRightIcon />
  </div>
)
